<script>
export default {
  props: {
    desiredHeight: {
      type: Number,
      required: true,
    },
    baseHeight: {
      type: Number,
      required: true,
    },
    progress: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: 'white',
    },
  },

  methods: {
    measureToHeightRatio(desiredPixel) {
      const constHeight = 300
      const ratio = constHeight / desiredPixel
      return this.baseHeight / ratio
    },
  },
}
</script>

<template>
  <svg
    :style="{ position: 'absolute', left: 0, top: 0 }"
    :width="measureToHeightRatio(desiredHeight)"
    :height="measureToHeightRatio(desiredHeight)"
    :viewBox="`${-measureToHeightRatio(desiredHeight) * 0.125} -${measureToHeightRatio(desiredHeight) * 0.125} ${
      measureToHeightRatio(desiredHeight) * 1.25
    } ${measureToHeightRatio(desiredHeight) * 1.25}`"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(-90deg)">
    <circle
      :r="measureToHeightRatio(desiredHeight) / 2 - measureToHeightRatio(10)"
      :cx="measureToHeightRatio(desiredHeight) / 2"
      :cy="measureToHeightRatio(desiredHeight) / 2"
      fill="transparent"
      :stroke="color"
      :stroke-width="measureToHeightRatio(3)"
      :stroke-dasharray="(measureToHeightRatio(desiredHeight) / 2 - measureToHeightRatio(10)) * 2 * Math.PI + 'px'"
      stroke-dashoffset="0"></circle>
    <circle
      :r="measureToHeightRatio(desiredHeight) / 2 - measureToHeightRatio(10)"
      :cx="measureToHeightRatio(desiredHeight) / 2"
      :cy="measureToHeightRatio(desiredHeight) / 2"
      :stroke="color"
      :stroke-width="measureToHeightRatio(8)"
      stroke-linecap="square"
      :stroke-dashoffset="
        (measureToHeightRatio(desiredHeight) / 2 - measureToHeightRatio(10)) * 2 * Math.PI -
        (progress * ((measureToHeightRatio(desiredHeight) / 2 - measureToHeightRatio(10)) * 2 * Math.PI)) / 100
      "
      fill="transparent"
      :stroke-dasharray="
        (measureToHeightRatio(desiredHeight) / 2 - measureToHeightRatio(10)) * 2 * Math.PI + 'px'
      "></circle>
  </svg>
</template>

<style lang="scss" module>
@import '@design';
</style>
